const B_1 = [
    {
        title: '资格审查',
        path: '/bidding/projectflow/kaibiao/zgsc/list'
    }
]          
export default {
    path: 'zgsc',
    component: () => import(/*webpackChunkName: 'bidding-kai-zgsc'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import('@views/bidding/views/project-flow/kai/zi-ge-shen-cha/list'),
            meta: {
                title: '标段列表',
                bread: B_1
            },
        },
        {
            path:"form",
            component: () => import('@views/bidding/views/project-flow/kai/zi-ge-shen-cha/form'),
            meta: {
                title: '资格审查',
                bread: B_1
            },
        },
        {
            path:"detail",
            component: () => import('@views/bidding/views/project-flow/kai/zi-ge-shen-cha/detail'),
            meta: {
                title: '资格审查',
                bread: B_1
            },
        },
        {
            path:"print",
            component: () => import('@views/bidding/views/project-flow/kai/zi-ge-shen-cha/sub-pages/print'),
            meta: {
                title: '打印资格审查结果',
                bread: B_1
            },
        },
        {
            path:"cqwtlist",
            component: () => import('@views/bidding/views/project-flow/kai/zi-ge-shen-cha/sub-pages/cqwt-list'),
            meta: {
                title: '资格审查问题 ',
                bread: B_1
            },
        },
        {
            path: 'cqwtlist/form',
            component: () => import('@views/bidding/views/project-flow/kai/zi-ge-shen-cha/sub-pages/cqwt-form'),
            meta: {
                title: '添加问题澄清',
                bread:B_1,
            }
        },
        
    ]
}